// API Base URL configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Helper: Basis-URL für direkte fetch()-Aufrufe (File-Uploads, Downloads, Dokument-Views)
export const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  return 'http://localhost:4001/api';
};

// Helper: Auth-Header aus gespeichertem JWT (falls vorhanden)
export const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Helper: JWT als ?token=-Query an eine URL anhängen — für Zugriffe, die keinen
// Header senden können (window.open, <a href>, <img src>).
export const withToken = (url) => {
  const token = localStorage.getItem('token');
  if (!token) return url;
  return url + (url.includes('?') ? '&' : '?') + 'token=' + encodeURIComponent(token);
};

// Helper function for API calls
export const apiCall = async (endpoint, options = {}) => {
  // Einheitliche Basis-URL (Prod: nginx-Proxy /api über HTTPS; Dev: lokaler Port)
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;

  // JWT automatisch mitsenden (ohne bestehende Header zu überschreiben)
  const optionsWithAuth = {
    ...options,
    headers: { ...authHeaders(), ...(options.headers || {}) },
  };

  const response = await fetch(url, optionsWithAuth);

  // Abgelaufene/ungültige Session: wenn wir eingeloggt zu sein glauben, aber ein
  // 401 zurückkommt, Session bereinigen und zum Login leiten (statt kryptischer Fehler).
  if (response.status === 401 && !endpoint.includes('/login') && localStorage.getItem('user')) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (typeof window !== 'undefined') {
      window.location.assign('/');
    }
    throw new Error('Sitzung abgelaufen – bitte erneut anmelden.');
  }

  if (!response.ok) {
    let errorData = {};
    let responseText = '';
    try {
      responseText = await response.text();
      // Versuche erst JSON zu parsen
      if (responseText.trim().startsWith('{') || responseText.trim().startsWith('[')) {
        errorData = JSON.parse(responseText);
      } else {
        // Wenn es HTML ist, gib eine bessere Fehlermeldung
        console.log('❌ Server antwortete mit HTML statt JSON:', responseText.substring(0, 200));
        errorData = { 
          error: `Server Error (${response.status}): Antwort war HTML, nicht JSON. Server möglicherweise down.`,
          htmlResponse: responseText.substring(0, 500) 
        };
      }
    } catch (e) {
      console.log('❌ Fehler beim Parsen der Error Response:', e);
      console.log('❌ Response war:', responseText.substring(0, 200));
      errorData = { 
        error: `Parsing Error: ${e.message}`,
        rawResponse: responseText.substring(0, 500)
      };
    }
    console.log('❌ API Error:', errorData);
    throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
  }
  
  return await response.json();
};
